import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';

export interface IProps {
  description: string;
  title: string;
  show: boolean;
  ready: boolean;
  progress: number;
  step: number;
  max: number;
  onStartClick: () => void;
}

const WorkoutIntro: React.FC<IProps> = ({ description, title, show, ready, progress, step, max, onStartClick }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }
  let actionLabel = t('postreg:Session.StartWorkout');
  if (!ready) {
    // calculate percentage
    const progressPercent = Math.round(progress * 100);
    // limit by 90
    const progressValue = Math.min(progressPercent, 90);
    actionLabel = t('common:Session.Loading', { progress: progressValue });
  }
  return (
    <div className="intro-screen">
      <div className="content-container">
        <h3>{t(`postreg:Session.${title}`)}</h3>
        <p>{t(`postreg:Session.${description}`, { step, max })}</p>
        <Button label={actionLabel} color={EButtonColor.blue} disabled={!ready} onClick={onStartClick} />
      </div>
    </div>
  );
};

export default WorkoutIntro;
